import * as yup from "yup";
import { INFORMATION_BOOKING_TYPE, INFORMATION_BOOKING_DESCRIPTION_MAX } from "../../../constants";
import { MAX_RICH_DESCRIPTION_LENGTH } from "../../../components/shared/RichDescription";


export const ForWhomMainPageSchema = yup.object().shape({
  bookingType: yup.string("Enter Booking type").required("Booking type is required").nullable(),
  bookingFor: yup
    .array()
    .of(
      yup.object({
        value: yup.string("Enter Booking for").required("Booking for is required"),
      })
    )
    .nullable()
    .when("bookingType", {
      is: INFORMATION_BOOKING_TYPE,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema
          .required("Booking for is required")
          .min(1, "Booking for is required"),
    }),
  redPandaProjects: yup
    .array()
    .of(yup.object())
    .nullable()
    .test("pred-user-project-required", "Project is required",
      function (value) {
        const { isPredUser, project, bookingType } = this.parent;
        if (bookingType === INFORMATION_BOOKING_TYPE) return true;
        if (!isPredUser) return true;
        const hasRedPanda =
          Array.isArray(value) && value.length > 0;
        const hasManual =
          typeof project === "string" && project.trim().length > 0;
        return hasRedPanda || hasManual;
      }
    )
    .test("max-10-projects", "You can select up to 10 projects",
      function (value) {
        if (!Array.isArray(value)) return true;
        return value.length <= 10;
      }
    ),
  project: yup
    .string("Enter project")
    .nullable()
    .notRequired(),
  description: yup
    .string("Enter description")
    .typeError("Invalid type")
    .max(
      INFORMATION_BOOKING_DESCRIPTION_MAX,
      `Description must be at most ${INFORMATION_BOOKING_DESCRIPTION_MAX} characters`
    )
    .when(["isPredUser", "bookingType"], {
      is: (isPredUser, bookingType) =>
        bookingType === INFORMATION_BOOKING_TYPE || !isPredUser,
      then: (schema) => schema.required("Description is required"),
      otherwise: (schema) => schema.nullable(),
    }),
  richDescription: yup
    .string()
    .typeError("Invalid type")
    .nullable()
    .max(
      MAX_RICH_DESCRIPTION_LENGTH,
      `Description must be at most ${MAX_RICH_DESCRIPTION_LENGTH} characters`
    ),
  hasHazardousMaterials: yup.boolean().nullable(),
  hazardousMaterialsText: yup.string().when(["hasHazardousMaterials", "bookingType"], {
    is: (hasHazardousMaterials, bookingType) => hasHazardousMaterials && bookingType === "Run",
    then: yup.string().required("Please list hazardous materials or confirm you are not bringing any"),
    otherwise: yup.string(),
  }),
  withAssistance: yup.boolean().default(false),
  assistanceReason: yup
    .string()
    .transform(v => (typeof v === "string" ? v.trim() : v))
    .when(["withAssistance", "bookingType"], {
      is: (withAssistance, bookingType) => withAssistance && bookingType === "Run",
      then: schema => {
        // For now we don't require assistance reason
        // return schema.required("Reason for assistance is required");
        return schema.notRequired();
      },
      otherwise: schema => schema.notRequired(),
    }),
  assistant: yup.string().nullable().notRequired(),
  assistentTime: yup
    .number()
    .transform((value, originalValue) => (String(originalValue).trim() === "" ? undefined : value))
    .nullable()
    .notRequired(),
});
